import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Segment
} from 'semantic-ui-react';
import {
  push,
  replace
} from 'react-router-redux';
import {
  intersection
} from 'lodash';
import authenticationActions from './../../store/actions/authenticationActions';
import feathersConnect from './../../providers/feathersConnect';

const authorize = (allowedRoles) => {
  return (WrappedComponent) => {
    class WithAuthorization extends Component {
      constructor (props) {
        super(props);
      }

      componentDidMount () {
        let {
          authentication,
          authAttempt,
          authSuccess,
          authFailure,
          routing
        } = this.props;

        authAttempt();

        this.props.feathers.authenticate()
          .then(response => {
            authSuccess(response.accessToken, response.user);
          })
          .catch(error => {
            console.log(error);
            authFailure(error);
          });
      }

      static mapStateToProps (state) {
        return {
          routing: state.routing,
          authentication: state.authentication.toJS({ deep: true })
        };
      }

      static mapDispatchToProps (dispatch) {
        return {
          navigate: (path) => {
            dispatch(push(path));
          },
          replace: (path) => {
            dispatch(replace(path));
          },
          authAttempt: () => {
            dispatch(authenticationActions.auth.authenticationAttempt('local'));
          },
          authSuccess: (token, user) => {
            dispatch(authenticationActions.auth.authenticationSuccess(token, user));
          },
          authFailure: (error) => {
            dispatch(authenticationActions.auth.authenticationFailure(error));
          }
        };
      }

      render () {
        let {
          authentication,
          routing
        } = this.props;
        let roles = [];

        if (authentication.user && authentication.user.roles.length) {
          roles = authentication.user.roles.map(r => r.name);
        }

        if (authentication.attempting) {
          return (
            <Container style={{ padding: 16 }}>
              <div className="loader">
                <div className="loader__figure"></div>
                <p className="loader__label">CARGANDO</p>
              </div>
            </Container>
          );
        } else {
          if (allowedRoles.length === 0) {
            let props = {
              ...this.props
            };

            delete props.authentication;
            delete props.dispatch;

            return <WrappedComponent {...props} />;
          } else if (intersection(allowedRoles, roles).length) {
            let props = {
              ...this.props
            };

            delete props.authentication;
            delete props.dispatch;

            return <WrappedComponent {...props} />;
          } else {
            return (
              <Container style={{ padding: 16 }}>
                <Grid doubling columns={2} centered>
                  <Grid.Column>
                    <Segment textAlign="center" color="red">
                      <Header as="h2">
                        401 - ACCESSO DENEGADO
                      </Header>
                      <Button onClick={this.props.navigate.bind(null, '/ingresar')} primary content="Ingresar" icon="sign in" />
                    </Segment>
                  </Grid.Column>
                </Grid>
              </Container>
            );
          }
        }
      }
    }

    return feathersConnect(
      connect(
        WithAuthorization.mapStateToProps,
        WithAuthorization.mapDispatchToProps
      )(WithAuthorization)
    );
  };
};

export default authorize;



// WEBPACK FOOTER //
// ./client/components/auth/authorize.js